import { render, staticRenderFns } from "./RawMaterialDetailInfo.vue?vue&type=template&id=e05af1e6"
import script from "./RawMaterialDetailInfo.vue?vue&type=script&lang=js"
export * from "./RawMaterialDetailInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports